const gridControl = ({ children }) => (
  <div class='grid-control'>
    {children}
  </div>
)

export default gridControl
